// extracted by mini-css-extract-plugin
export var marginNegative = "_6a-5 _6a-3 _6a-1";
export var marginPositive = "_6a-4 _6a-3 _6a-1";
export var modalContent = "_6a-6";
export var samplesTable = "_6a-8";
export var samplesTableContainer = "_6a-7";
export var statBox = "_6a-a";
export var tableCell = "_6a-1";
export var tableCellCenter = "_6a-2 _6a-1";
export var tableCellRight = "_6a-3 _6a-1";
export var tableHeader = "_6a-0";
export var trackingNumber = "_6a-9";